module.exports = {
  add_more: 'Ajouter plus',
  provideFullAddress: 'Vous devez écrire votre adresse complète',
  dropdownBoth: 'Veuillez remplir tous les champs',
  dropdownDay: 'Veuillez choisir le jour souhaité',
  dropdownTime: "Veuillez choisir l'heure souhaitée",
  pictureDescription: 'Ajouter une description (optionnel)',
  changeEmail: "Oui, changer l'adresse",
  dontChangeEmail: "Non, conserver l'adresse",
  yes: 'Oui',
  no: 'Non',
  'next-step': 'Suivant',
  'next-step-wizard': 'Suivant',
  step: 'Etape',
  off: 'Off',
  'first-step-wizard': 'Oui, débutons',
  'last-step': 'Recevoir des offres',
  'go-back': 'Précédent',
  'go-back-wizard': 'Etape précédente',
  understood: "J'ai compris !",
  'company-placeholder': 'Nom société',
  'company-autocomplete-label': '',
  'company-label': 'Nom de la société',
  'address-placeholder': 'Nom de rue',
  address_no_number_placeholder: 'Nom de rue ',
  'address-label': 'Adresse',
  'address-street-number-label': 'N° de rue',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': "Cette adresse n'a pas de numéro",
  'address-not-found': 'Je ne trouve pas mon adresse',
  'address-no-match': 'Pas de résultats',
  'address-choose-from': 'Choisir parmi plusieurs adresses',
  'address-invalid': 'Cette adresse est invalide',
  'address-missing': 'Adresse manquante',
  'address-missing-street-number': 'Numéro de rue manquant',
  address_alert: 'Avez-vous bien écrit votre adresse ?',
  address_missing_city: 'La ville est manquante',
  address_not_verified:
    "Nous rencontrons des difficultés à trouver votre adresse, mais si vous êtes sûr(e) de l'avoir bien écrite, vous pouvez continuer en saisissant un code postal valide ci-dessous.",
  postcode_needed: 'Saisissez un code postal valide pour continuer.',
  'phone-invalid-length': '10 chiffres minimum',
  'zip-error': 'Code postal manquant',
  'zip-label': 'Code postal',
  'zip-does-not-exist': "Le code postal n'existe pas",
  'zip-warning': "Etes-vous sûrs d'avoir écrit le bon code postal ?",
  zip_placeholder: '12345',
  'name-label': 'Nom-Prénom',
  'date-format': 'JJ/MM/AA',
  'date-label': 'Date (6 chiffres)',
  'birthdate-label': 'Date de naissance (6 chiffres)',
  'national-identity-label': '',
  'national-identity-placeholder': '',
  'national-identity-invalid': '',
  'national-identity-identical': '',
  'bank-account-label': 'Votre numéro de compte bancaire',
  'measuring-id-invalid': '',
  'bank-account-placeholder': '',
  'bank-account-invalid': 'Le numéro de compte est invalide',
  'organization-identity-label': 'Immatriculation de la copropriété',
  'organization-identity-placeholder': 'AB-1234567',
  'organization-identity-invalid': '',
  'date-invalid': 'La date est invalide',
  'name-placeholder': 'Nom-Prénom',
  'name-invalid': 'Ce nom est invalide',
  'email-alert-message': 'Avez-vous écrit la bonne adresse email ?',
  'email-label': 'Email',
  'email-placeholder': 'nom@domaine.fr',
  'email-does-not-exist': "Cette adresse email n'existe pas",
  'email-invalid': "Cette adresse email n'est pas valide",
  email_did_you_mean: 'Voulez vous dire',
  'fetching-information': 'Récupération des informations',
  'comment-label': 'Information supplémentaire',
  'comment-placeholder': 'Optionnel, ex : besoins particuliers ou autre information pertinente.',
  'phone-alert-message': 'Avez-vous écrit le bon numéro de téléphone ?',
  'phone-label': 'Numéro de téléphone',
  'phone-invalid': 'Le numéro de téléphone est invalide',
  'phone-must-begin-with-+': 'Le numéro de téléphone doit commencer par +',
  'phone-foreign': 'Numéro de téléphone étranger',
  'phone-placeholder': '0612345678',
  'phone-foreign-placeholder-prefix': '33',
  'error-x-numbers': 'Doit contenir --x-- chiffres',
  'error-x-letters': 'Doit contenir --x-- lettres',
  'error-min-rooms': 'Vous devez choisir au moins une catégorie',
  'error-min-x-letters': 'Doit contenir au moins --x-- lettres',
  'error-min-x-numbers': 'Doit contenir au moins --x-- chiffres',
  'error-max-x-numbers': 'Doit contenir --x-- chiffres maximum',
  'error-inbetween-numbers': 'Doit contenir --x-----y chiffres',
  'error-must-consist-of-x-letters': 'Doit contenir au moins --x--lettres',
  'error-mandatory': 'Ce champ est obligatoire',
  'error-choose': 'Choisissez au moins une option',
  'error-min-age':
    'Malheureusement, nos offres ne sont disponibles que pour les clients de plus de --x-- ans',
  'error-must-accept': 'Doit être accepté',
  'error-only-digits': 'Chiffres uniquement',
  privacy:
    'Nous protégeons votre vie privée. Les données partagées sont cryptées et envoyées via un réseau sécurisé.',
  'privacy-policy':
    '<h4>Politique de confidentialité</h4><p><strong>Qui est responsable du traitement de vos données ?</strong></p><p>NETTBUREAU AS (ci-après, “--x--”) est responsable pour le traitement de vos données personnelles.</p></ br><p><strong>Quelles sont les données que nous collectons ?</strong></p> <p>Afin de vous fournir les services proposés sur son Site Internet, --x-- peut avoir besoin de collecter les données personnelles suivantes :</p></br><p><strong>Données d’identification :</strong> nom et prénoms.</p></br><p><strong>Coordonnées :</strong> adresse email et numéro de téléphone.</p></br><p><strong>Données résidentielles :</strong> adresse et code postal.</p></br><p><strong>A quelles fins sont recueillies vos données personnelles ?</strong></p><p>Les données personnelles recueillies par --x-- peuvent être utilisées pour les raisons suivantes : La fourniture d’un service d’aide à l\'Utilisateur (internaute) afin qu’il trouve l’offre qui correspond le mieux à ses besoins parmi les différentes sociétés avec lesquelles --x-- collabore. L’envoi de vos données aux sociétés avec lesquelles --x-- collabore. Cet partage a pour but de permettre aux sociétés concernées d’envoyer à l’Utilisateur des informations et des communications commerciales qui pourraient l’intéresser, par courrier, téléphone, email, SMS/MMS, ou par tout moyen de communication électronique équivalent.</p></br></br><p><strong>Sur quelle base légale --x-- se fonde pour traiter vos données ?</strong><p/><p>Le traitement des données personnelles par --x-- repose sur le consentement des Utilisateurs. </p></br><p><strong>Questions</strong></p><p>Si vous avez des questions sur notre politique de confidentialité, merci de nous contacter en envoyant un email à l’adresse suivante : privacy@nettbureau.com</p><p>Nous vous invitons également à consulter notre <a href="--y--" target="__blank">politique de confidentialité</a>.</p></br>',
  close: 'Fermer',
  error_radio_button: 'Vous devez choisir une catégorie',
  invalid_day: 'La date est invalide',
  invalid_day_in_month: "Cette date n'existe pas à ce mois",
  invalid_month: 'Le mois est invalide',
  invalid_year: "L'année est invalide",
  invalid_country: 'Le pays est invalide',
  label_birthdate: 'Date de naissance',
  label_date: 'Date',
  label_day: 'Jour',
  label_month: 'Mois',
  label_year: 'Année',
  locale: '',
  new_locale: '',
  missing_date: 'La date est manquante',
  missing_month: 'Le mois est manquant',
  missing_year: "L'année est manquante",
  'datepicker-button': 'Choisissez une date',
  email_wrong_user_account:
    "Etes-vous sûrs d'avoir écrit l'identifiant de votre adresse e-mail correctement ?",
  email_wrong_email_address: "Etes-vous sûrs d'avoir écrit la bonne adresse email ?",
  not_valid_municipality: 'La ville est invalide',
  not_valid_state: 'Le pays est invalide',
  'invalid-file-size': 'La taille maximum pour ce fichier est',
  'invalid-file-type': 'Fichier invalide, les fichiers supportés sont',
  'drop-files-first': 'Déposez vos fichiers ici ou',
  'drop-files-last': 'Cliquez ici pour choisir/prendre une photo',
  'vehicle-label': "Numéro de plaque d'immatriculation",
  'vehicle-invalid': "Le numéro de plaque d'immatriculation est invalide",
  'leazard-error-boundary-headline': "Désolé, quelque chose n'a pas fonctionné",
  'leazard-error-boundary-description':
    'Merci de cliquer de nouveau sur le bouton ci-dessous. Si le problème persiste :',
  'leazard-error-boundary-contact-customer-service': 'Contactez le service client',
  'leazard-error-boundary-email-subject': 'Erreur de formulaire',
  'leazard-error-boundary-button-text': "Merci d'essayer de nouveau",
  'sms-verification-label': 'Vérification par SMS',
  'sms-verification-tinyLabel: Vennligst skriv inn koden som vi nettopp sendte deg via SMS til ditt mobiltelefonnummer':
    "Merci d'entrer le code qui vient d'être envoyé  par SMS au --xx--",
  'sms-verification-error-message': 'Code faux',
  'sms-verification-code-not-received-first': 'Vous n’avez pas reçu de code ? Cliquez ',
  'sms-verification-code-not-received-link': 'ici',
  'sms-verification-code-not-received-last': ' pour réessayer.',
  'sms-verification-code-is-sent-again': 'Un nouveau code a été envoyé',
  'sms-verification-code-retry-error':
    'Trop de tentatives, merci d’attendre 30 secondes avant de réessayer',
  'leazard-two-factor-header': 'Presque fini !',
  'leazard-two-factor-help-text':
    'Un code de confirmation vous a été envoyé par SMS du +47 59 44 45 00.',
  'leazard-two-factor-submit': 'Envoyé',
  'leazard-two-factor-label': 'Entrez votre code pour confirmer.',
  'leazard-loading-text': 'Traitement des données',
  'recaptcha-disclaimer': 'Ce site web est protégé par reCAPTCHA.',
};
